<div class="d-flex align-items-center">    
    <switchery-ios class="mt-1" [(ngModel)]="debugSvc.isActif" size="small" name="topDebug" offLabel="Debug">
    </switchery-ios>
    <select id="cboProfils" *ngIf="debugSvc.isActif" class="form-control" name="isActif" [(ngModel)]="debugSvc.selectedProfilId">
        <option *ngFor="let profil of lstProfils" [value]="profil.Id">
            <paflabel [lblCod]="profil.LblCod"></paflabel>
        </option>
    </select>
</div>